<template>
  <div v-loading="loading">
    <el-form ref="form" :model="queryParams" label-width="80px">
      <el-form-item label-width="0">
        <el-transfer
          filterable
          ref="transfer"
          id="transfer"
          :titles="['常规技能', '热门技能']"
          v-model="queryParams.ids"
          :data="listInfo"
          @change="handleChange"
          target-order="push"
          @mouseover.native="addHover"
        >
          <span
            slot-scope="{ option }"
            :draggable="!option.disabled"
            @dragstart="drag($event, option)"
            >{{ option.label }} / {{ option.nickname }}</span
          >
        </el-transfer>
      </el-form-item>
      <el-form-item label-width="0">
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="cancel">取 消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import map from "../../datamap";
import api from "../api";
const { service, workCateList, common } = api;
import domeSort from "./domeSort";
export default {
  components: { domeSort },
  data() {
    return {
      loading: false,
      value: [],
      data: [],
      ArrayIds: [], // 最新的数组ArrayIds
      oldData: [], // 回显的数据
      draggingKey: null,
      queryParams: {
        ids: [],
      },
      listInfo: [], // 列表数据
      loading: false,
      filter: {},
      limit: 999,
      pageNum: 1,
    };
  },
  created() {
    this.getList();
  },

  methods: {
    // 滑过显示全部内容
    addHover(e) {
      console.log(e, "eeeeeeeee");
      const target = e.target;
      if (target.title) return;
      target.title = target.innerText;
    },

    getList() {
      this.loading = true;
      let obj = {};
      (obj.limit = 999),
        (obj.pageNum = 1),
        service.findHotList(obj).then((res) => {
          if (res.data.code == 200) {
            //  回显
            this.queryParams.ids = res.data.data.hotList.map((item) => item.id);
            // 获取已选中的数据
            const hotData = [];
            res.data.data.hotList.forEach((item, index) => {
              hotData.push({
                ksy: item.id,
                sort: index,
                label: item.serviceTitle,
              });
            });
            this.oldData = hotData;

            // 查询列表数据
            this.listInfo = res.data.data.notHotList.map((item) => {
              return {
                key: item.id,
                label: item.serviceTitle,
                nickname: item.nickname,
              };
            });
          } else {
            this.$message.error(res.data.desc);
          }
          this.loading = false;
        });
    },
    handleChange(value, direction, movedKeys) {
      const data = [];
      value.forEach((item, index) => {
        data.push({
          id: item,
          sort: index,
        });
      });
      this.ArrayIds = data;
      // console.log(value, "<<<change改变的数据", this.ArrayIds);

      return data;
    },
    onSubmit() {
      let obj = {};
      if (this.ArrayIds.length > 0) {
        obj.serviceDTOS = this.ArrayIds;
      } else {
        obj.serviceDTOS = this.oldData;
      }
      service.editHot(obj).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("操作成功！");
        } else {
          this.$message.error(res.data.desc);
        }
      });
    },
    cancel() {
      this.$router.push({
        path: "/services",
      });
    },
    // 拖拽
    drag(event, option) {
      // console.log(event, "eeeeeeeee", option);
      this.draggingKey = option.key;
    },
    test() {
      const transfer = this.$refs.transfer.$el;
      const rightPanel = transfer
        .getElementsByClassName("el-transfer-panel")[1]
        .getElementsByClassName("el-transfer-panel__body")[0];
      const rightEl = rightPanel.getElementsByClassName(
        "el-transfer-panel__list"
      )[0];
      // 第一步，获取行容器
      const wrapperRow = rightEl;

      var that = this; // 存一份指向

      // 第二步，给行容器指定对应拖拽规则
      Sortable.create(wrapperRow, {
        onEnd({ newIndex, oldIndex }) {
          // 首先删除原来的那一项，并且保存一份原来的那一项，因为splice返回的是一个数组，数组中的第一项就是删掉的那一项

          const currRow = that.queryParams.ids.splice(oldIndex, 1)[0];
          // console.log("currRow", currRow);
          // // 然后把这一项加入到新位置上
          that.queryParams.ids.splice(newIndex, 0, currRow);

          const data = [];
          const value = that.queryParams.ids;
          value.forEach((item, index) => {
            data.push({
              id: item,
              sort: index,
            });
          });
          that.ArrayIds = data;
          // console.log("拖拽之后最新的数组ArrayIds>>>>", that.ArrayIds);
        },
      });
    },
  },
  mounted() {
    document.body.ondrop = function (event) {
      // 阻止拖拽的时候火狐浏览器打开新的页面
      event.preventDefault();
      event.stopPropagation();
    };
    this.test();
  },
};
</script>

<style >
.el-transfer-panel {
  width: 500px !important;
  min-height: 500px;
}
.el-transfer-panel__list {
  min-height: 400px;
}
.el-transfer__buttons {
  padding: 0 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/service/domeSort.vue